module.exports = __webpack_public_path__ + "img/portfolio-3.70fae66f.jpg";